import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
    getDoc,
  doc,
  setDoc,
  updateDoc,
  arrayUnion
} from "firebase/firestore";

export default function CreateGroupModal({ onClose }) {
  const user = localStorage.getItem("user");

  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const load = async () => {
      const me = await getDoc(doc(db, "users", user));
            if (!me.exists()) return;

            const friends = me.data().contacts || [];

            const list = await Promise.all(
            friends.map(async (f) => {
                const snap = await getDoc(doc(db, "users", f));
                return {
                id: f,
                ...snap.data()
                };
            })
            );

            setUsers(list);
    };

    load();
  }, [user]);

  const toggle = (id) => {
    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  const createGroup = async () => {
    if (selected.length === 0) return;

    const id = "group_" + Date.now();
    const members = [user, ...selected];

    await setDoc(doc(db, "chats", id), {
      isGroup: true,
      name: name.trim() || null,
      description,
      members,
      admin: user,
      createdAt: Date.now(),
      lastMessage: "",
      updatedAt: Date.now(),
    });

    await Promise.all(
      members.map((u) =>
        updateDoc(doc(db, "users", u), {
          groups: arrayUnion(id),
        })
      )
    );

    onClose();
  };

  const filteredUsers = users.filter((u) =>
    u.username?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        
        {/* HEADER */}
        <div style={styles.header}>
          <div>Новая группа</div>
          <div style={styles.close} onClick={onClose}>✕</div>
        </div>

        {/* НАЗВАНИЕ */}
        <input
          placeholder="Название группы"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={styles.input}
        />

        {/* ОПИСАНИЕ */}
        <textarea
          placeholder="Описание группы"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={styles.textarea}
        />

        {/* ПОИСК */}
        <input
          placeholder="Поиск пользователей..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={styles.input}
        />

        {/* ВЫБРАННЫЕ */}
        {selected.length > 0 && (
          <div style={styles.selectedRow}>
            {selected.map((id) => {
              const u = users.find((x) => x.id === id);
              if (!u) return null;

              return (
                <img
                  key={id}
                  src={u.avatar || "https://via.placeholder.com/40"}
                  style={styles.selectedAvatar}
                  title={u.username}
                />
              );
            })}
          </div>
        )}

        {/* USERS */}
        <div style={styles.list}>
          {filteredUsers.map((u) => (
            <div
              key={u.id}
              onClick={() => toggle(u.id)}
              style={{
                ...styles.user,
                background: selected.includes(u.id)
                  ? "rgba(255,255,255,0.1)"
                  : "transparent",
              }}
            >
              <img
                src={u.avatar || "https://via.placeholder.com/40"}
                style={styles.avatar}
              />

              <div style={{ flex: 1 }}>
                {u.username}
              </div>

              {selected.includes(u.id) && (
                <div style={styles.check}>✓</div>
              )}
            </div>
          ))}
        </div>

        {/* BUTTON */}
        <button style={styles.btn} onClick={createGroup}>
          Создать
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(12px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  },

  modal: {
    width: 360,
    padding: 18,
    borderRadius: 20,
    background: "rgba(20,20,20,0.6)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.08)",
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: 14,
    opacity: 0.9,
  },

  close: {
    cursor: "pointer",
    opacity: 0.6,
  },

  input: {
    padding: 10,
    borderRadius: 10,
    border: "none",
    background: "rgba(255,255,255,0.05)",
    color: "#fff",
  },

  textarea: {
    padding: 10,
    borderRadius: 10,
    border: "none",
    minHeight: 60,
    resize: "none",
    background: "rgba(255,255,255,0.05)",
    color: "#fff",
  },

  list: {
    maxHeight: 180,
    overflowY: "auto",
  },

  user: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: 10,
    borderRadius: 10,
    cursor: "pointer",
    transition: "0.2s",
  },

  avatar: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    objectFit: "cover",
  },

  check: {
    fontSize: 14,
    opacity: 0.7,
  },

  selectedRow: {
    display: "flex",
    gap: 6,
    flexWrap: "wrap",
  },

  selectedAvatar: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    objectFit: "cover",
    border: "1px solid rgba(255,255,255,0.2)",
  },

  btn: {
    marginTop: 6,
    padding: 12,
    borderRadius: 12,
    border: "none",
    cursor: "pointer",
    background: "#fff",
    color: "#000",
    fontWeight: 500,
  },
};